import { useState } from "react"
import { useTranslation } from "react-i18next"
import { analytics } from "@/telemetry/amplitude"
import expressModeUrl from "@assets/express_mode.png?url"
import advancedModeUrl from "@assets/advanced_mode.png?url"
import clsx from "clsx"

export type SetupType = "express" | "advanced" | "images"

export const SelectSetup = (props: { onSelect: (setup: SetupType) => void }) => {
	const { t } = useTranslation("components")
	const [selected, setSelected] = useState<SetupType>("express")

	const handleSelect = (type: SetupType, target: EventTarget) => {
		setSelected(type)
		props.onSelect(type)
		analytics.trackEvent(
			{
				type: "click",
				label: "select_setup_type",
				value: selected,
			},
			target,
		)
	}

	return (
		<div className="flex size-full min-h-0 flex-row items-start space-x-4 overflow-y-auto">
			{/*
			/*
				Change px-8 to px-[clamp(1rem,2.5vw,2rem)] py-[clamp(0.75rem,2.5vh,2rem)]
				This is to reduce padding when necessary; the scrollbar will only appear when the padding can no longer be reduced.
			*/}
			<div
				data-testid="setup_option_advanced"
				className={clsx(
					"min-h-48 outline outline-2 outline-offset-[-2px]",
					selected === "advanced" ? "outline-accent-600" : "outline-transparent",
					"flex size-full flex-col items-start justify-center space-y-4 rounded-lg bg-base-700 px-[clamp(1rem,2.5vw,2rem)] py-[clamp(0.75rem,2.5vh,2rem)]",
				)}
				onClick={(e) => handleSelect("advanced", e.target)}
			>
				<img
					src={advancedModeUrl}
					className="-ml-4 h-[clamp(56px,14vh,112px)] w-auto max-w-full object-contain"
				/>
				<div className="text-sm">{t("selectSetupDialog.advancedSetup")}</div>
				<div className="text-xs text-base-400">
					{t("selectSetupDialog.advancedDescription")}
				</div>
			</div>

			<div
				data-testid="setup_option_express"
				className={clsx(
					"min-h-48 outline outline-2 outline-offset-[-2px]",
					selected === "express" ? "outline-accent-600" : "outline-transparent",
					"flex size-full flex-col items-start justify-center space-y-4 rounded-lg bg-base-700 px-[clamp(1rem,2.5vw,2rem)] py-[clamp(0.75rem,2.5vh,2rem)]",
				)}
				onClick={(e) => handleSelect("express", e.target)}
			>
				<img
					src={expressModeUrl}
					className="-ml-5 h-[clamp(56px,14vh,112px)] w-auto max-w-full object-contain"
				/>
				<div className="text-sm">{t("selectSetupDialog.expressSetup")}</div>
				<div className="text-xs text-base-400">
					{t("selectSetupDialog.expressDescription")}
				</div>
			</div>
		</div>
	)
}
